import { useState, useEffect } from 'react';

const API = window.location.origin;

// Returns { progressMap: { [poemId]: status }, error } for the given user.
export function useUserProgress(userId) {
  const [progressMap, setProgressMap] = useState({});

  useEffect(() => {
    if (!userId) return;
    const ctrl = new AbortController();
    fetch(`${API}/api/users/${userId}/progress`, { signal: ctrl.signal })
      .then(r => { if (!r.ok) throw new Error('non-ok'); return r.json(); })
      .then(({ progress = [] }) => {
        const map = {};
        progress.forEach(({ status, poem: p }) => {
          if (p?.id) map[p.id] = status;
        });
        setProgressMap(map);
      })
      .catch(() => {});
    return () => ctrl.abort();
  }, [userId]);

  return progressMap;
}
